import axios, { type AxiosInstance } from 'axios';

import { env } from '@config/env';

import { setupInterceptors } from './interceptors';

export const httpClient: AxiosInstance = axios.create({
  baseURL: env.API_BASE_URL,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

setupInterceptors(httpClient);

export type { AxiosInstance };
